import * as React from "react";
import Svg, { Path } from "react-native-svg";
function LeftBlackArrowIcon(props) {
    return (React.createElement(Svg, { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement(Path, { d: "M7.439 10c0 .083.014.16.041.229.028.07.077.139.146.208l4.125 4.125c.111.112.26.164.448.157a.64.64 0 00.448-.178c.139-.138.198-.288.177-.447a.783.783 0 00-.198-.428L8.96 10l3.667-3.667a.68.68 0 00.188-.448.493.493 0 00-.188-.448.46.46 0 00-.437-.177.811.811 0 00-.459.198L7.626 9.562a.635.635 0 00-.146.209.612.612 0 00-.041.229z", fill: props.color })));
}
export default LeftBlackArrowIcon;
